export default __webpack_public_path__ + "static/media/weixinNew.c30c08e1.jpg";